<template>
    <div>
        <md-dialog :md-active.sync="showConfirmDialog" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                <!-- <md-button style="background-color: #cd2838; width: 35px; height: 35px;" class="md-fab md-primary" @click="deleteCuenta(item.id)"> -->
                    <md-icon style="background-color: #cd2838; color: white; width: 35px; height: 35px; border-radius: 4px;">warning</md-icon>
                <!-- </md-button> -->
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="mb-3">
                    <b-col v-if="borraUno" md="5" lg="7" class="mx-auto">
                        <h5>{{ labels.texto }}</h5>
                    </b-col>
                    <b-col v-if="!borraUno" md="5" lg="7" class="mx-auto">
                        <h5>{{ labels.texto1 }}</h5>
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="confirmDelete">{{ labels.aceptar }}</md-button>
                    <md-button class="md-accent" @click="cancelDelete">{{ labels.cancelar }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>
<script>
export default {
    name: 'DialogConfirm',
    props: ['showConfirmDialog','borraUno'],
    data: () => ({
      
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar Niif",
                    texto : "¿Seguro desea eliminar este registro?",
                    texto1 : "¿Seguro desea eliminar todos los registros?",
                    aceptar : "Aceptar",
                    cancelar : "Cancelar"
                }
            }else{
                return {
                    title: "Edit Niif",
                    texto : "¿Surely you want to delete this record?",
                    texto1 : "¿Surely you want to delete all records?",
                    aceptar : "Accept",
                    cancelar : "Cancel"
                }
            }
        }
    },
    methods: {
        cancelDelete(){
            this.$emit('cancelDel', false);
        },
        confirmDelete(){
            this.$emit('confirmDelete');
        }
    }
}
</script>
